<template>
    <div class="flex flex-col gap-12 shadow bg-white rounded p-16 border border-white">
        <div class="flex justify-between">
            <h2 class="flex items-center font-semibold text-heading-2">
                <svg-icon type="forum" class="text-primary w-24 h-24 mr-8"/>
                {{ $t('interims.internal_notes.title') }}
            </h2>
            <simple-button
                class="ms-auto"
                icon="add-circle"
                look="primary"
                small
                v-if="canManage"
                @click="startCreatingNote"
            >
                {{ $t('interims.internal_notes.add_new') }}
            </simple-button>
        </div>

        <div v-if="notes.length > 0">
            <alternating-list
                :items="notes"
                hide-duplicate
                label="title"
                @show="startShowingNote"
                @edit="startEditingNote"
                @delete="startDeletingNote"
            />
        </div>

        <simple-button
            class="ms-auto"
            icon="add-circle"
            look="primary"
            small
            v-if="canManage && notes.length > 8"
            @click="startCreatingNote"
        >
            {{ $t('interims.internal_notes.add_new') }}
        </simple-button>

        <popup-modal
            v-if="showingNote"
            position="center"
            :title="showingNote ? showingNote.title : null"
            @close="stopShowingNote"
        >
            <div class="w-600" v-html="showingNote ? showingNote.content : null"></div>
        </popup-modal>

        <edit-resource
            custom-class="w-764"
            v-if="creatingNote || editingNote"
            :title="creatingNote ? $t('interims.internal_notes.form.title') : $t('interims.internal_notes.form.edit_title')"
            :form="form"
            @submit="addNote"
            @close="stopCreatingNote"
        >
            <simple-input v-model="form.title" class="mb-32">
                {{ $t('interims.internal_notes.form.name') }}
            </simple-input>
            <wysiwyg v-model="form.content">
                {{ $t('interims.internal_notes.form.content') }}
            </wysiwyg>
        </edit-resource>

        <popup-modal-confirm
            v-if="deletingNote"
            :message="$t('general.delete-nota')"
            show-exclamation
            :working="performingDeleteRequest"
            @close="stopDeletingNote"
            @confirm="deleteNote"
        />
    </div>
</template>

<script>
import SvgIcon from './ui/SvgIcon';
import Interim from "../models/Interim";
import PopupModal from "./ui/PopupModal";
import SimpleButton from "./ui/SimpleButton";
import Form from "../etc/forms/Form";
import EditResource from "./ui/EditResource";
import SimpleInput from "./forms/Input";
import Wysiwyg from "./forms/Wysiwyg";
import * as interims from '../services/InterimService';
import {normalizeJson} from "../../shared/helpers";
import PopupModalConfirm from "./ui/PopupModalConfirm";
import InterimInternalNote from "../models/InterimInternalNote";
import AlternatingList from "./ui/AlternatingList.vue";
import {useRepo} from 'pinia-orm';

export default {
    components: {
        AlternatingList,
        PopupModalConfirm, Wysiwyg, SimpleInput, EditResource, SimpleButton, PopupModal, SvgIcon},
    props: {
        interim: Interim,
        canManage: Boolean,
    },
    data() {
        return {
            showingNote: false,

            creatingNote: false,
            editingNote: false,
            form: this.generateForm(),

            deletingNote: false,
            performingDeleteRequest: false
        }
    },
    computed: {
        notes() {
            if (!this.interim)
                return [];

            return this.interim.internal_notes;
        }
    },
    methods: {
        generateForm() {
            return new Form([
                {name: 'title'},
                {name: 'content'}
            ])
        },
        startShowingNote(note) {
            this.showingNote = note;
        },
        stopShowingNote() {
            this.showingNote = false;
        },
        startCreatingNote() {
            this.creatingNote = true;
        },
        stopCreatingNote() {
            this.creatingNote = false;
            this.editingNote = false;
            this.form = this.generateForm();
        },
        startEditingNote(note) {
            this.editingNote = note;
            this.form.title = note.title;
            this.form.content = note.content;
        },
        startDeletingNote(note) {
            this.deletingNote = note;
        },
        stopDeletingNote() {
            this.deletingNote = false;
        },

        addNote() {
            this.form.submit(data => {
                if (this.creatingNote) {
                    return interims.storeNote(this.interim.id, {
                        data: {
                            attributes: data
                        }
                    })
                } else {
                    return interims.updateNote(this.interim.id, this.editingNote.id, {
                        data: {
                            attributes: data
                        }
                    })
                }
            }).then(result => {
                return useRepo(Interim).save(normalizeJson(result))
            }).then(() => {
                this.stopCreatingNote();
            })
        },
        deleteNote() {
            this.performingDeleteRequest = true;

            interims.destroyNote(this.interim.id, this.deletingNote.id)
            .then(result => {
                return useRepo(Interim).save(normalizeJson(result))
            }).then(() => {
                return useRepo(InterimInternalNote).destroy(this.deletingNote.id)
            }).then(() => {
                this.stopDeletingNote();
                this.performingDeleteRequest = false;
            })
        }
    }
}
</script>
